const requestSync = URL =>
{
    var request = new XMLHttpRequest()
    request.open('GET', URL, false)
    request.send(null)

    if (request.status >= 200 && request.status < 300)
    {
        try
        {
            return JSON.parse(request.responseText)
        }
        catch(error)
        {
            console.error(error)
            return { success: false, message: 'Bad JSON' }
        }
    }

    console.error('Error on load ' + URL)
    console.log(request)
    return { success: false, message: 'Bad URL' }
}

const requestAsync = URL =>
{
    return new Promise((resolve, reject) =>
    {
        let request = new XMLHttpRequest()
        request.open('GET', URL)
        request.onload = () =>
        {
            if (request.status >= 200 && request.status < 300)
            {
                resolve(request.responseText)
            }
            else
            {
                reject(request.statusText)
            }
        }

        request.onerror = () => reject(request.statusText)
        request.send(null)
    })
        .then(body => JSON.parse(body))
}


export { requestSync, requestAsync }
